import PrimaryButton from "features/shared/components/buttons/PrimaryButton.styled";
import StyledSelectFileButton from "features/shared/components/select-file-button/styles/StyledSelectFileButton";
import { Summary } from "features/shared/styles/typography/Summary.styled";
import styled from "styled-components";

import FilesContainer from "../components/files-list/styles/FilesContainer";

const StyledDocumentUpload = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  min-width: 295px;
  max-width: 512px;
  padding: 24px;
  box-sizing: border-box;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusChecklistCard};
  display: flex;
  flex-direction: column;

  .main-prompt {
    margin-bottom: 24px;
  }

  .second-side-prompt {
    margin: 12px 0 4px 0;
    text-align: center;
  }

  ${Summary} {
    margin-bottom: 12px;
  }

  ${StyledSelectFileButton} {
    margin-top: 12px;
  }

  ${FilesContainer} {
    margin: 12px 0;
  }

  ${PrimaryButton} {
    margin-top: 12px;
  }
`;

export default StyledDocumentUpload;
